import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { storageLocationRoutes } from './storage-location.routes';
import { StorageLocationProductService } from './services/storage-location-product.service';
import { StorageLocationService } from './services/storage-location.service';
import { StorageLocationProductRepository } from './repositories/storage-location-product.repository';
import { StorageLocationRepository } from './repositories/storage-location.repository';

export function provideStorageLocation() {
  return [
    provideSoftAppsModule(
      {
        icon: 'fa-regular fa-scanner-gun',
        name: 'mde/storage-location',
        route: 'storage-location/select',
        title: '#STORAGE_LOCATION.TITLE',
        permission: 'ROLE_LOCATIONASSIGNMENT_SERVICE',
      },
      withSoftAppsModuleRoutes({ app: storageLocationRoutes }),
      withSoftAppsModuleTranslation({ de })
    ),
    StorageLocationProductRepository,
    StorageLocationProductService,
    StorageLocationRepository,
    StorageLocationService,
  ];
}
